<template>
  <main class="account">
    <section class="account__column account__column--cta">
      <div class="heading-container">
        <h1 data-cy="login-title">{{ $t('pages.locked.introHead') }}</h1>
        <i18next path="pages.locked.alertLocked" tag="p">
          <span v-if="time.duration">
            {{
              $t('pages.locked.alertLockedTime', {
                duration: time.duration,
                unit: time.unit
              })
            }}</span
          >
        </i18next>
      </div>
      <div class="row">
        <div class="col-sm-6 u-margin-bottom-4x">
          <BaseButton to="/request-password">
            {{ $t('pages.login.buttonForgotPassword') }}
          </BaseButton>
        </div>
      </div>
    </section>
    <section class="account__column account__column--showcase">
      <img src="/img/locked.svg" class="account__img" />
    </section>
  </main>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { BaseButton } from '@te/cdev-design-system';
import { Period, minutesToText } from '@/common/helpers/format';

export default defineComponent({
  components: {
    BaseButton
  },
  metaInfo() {
    return {
      title: this.$t('pages.locked.title')
    };
  },
  computed: {
    time(): Period {
      const { duration } = this.$route.query;
      const durationInMinutes = +duration / 60;

      return minutesToText(durationInMinutes);
    }
  }
});
</script>
